<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2023-01-11 10:12:01
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2023-01-11 17:22:35
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\pushManagement\dialogComponent\onlineCourse.vue
 * @tips: 在线教程弹窗组件
-->
<template>
    <div class=''>
        <el-dialog title="在线教程" :visible.sync="onlineJia" v-if="onlineJia" width="50%" center top="4vh">
            <div style="margin-bottom:20px;display:flex;justify-content: space-between;">
                <el-input style="width:75%;margin-right:12px" placeholder="请输入内容" clearable maxlength="20"
                    prefix-icon="el-icon-search" v-model="keyWord"></el-input>
                <span>
                    <el-button @click="restSearch">重置</el-button>
                    <el-button type="primary" @click="onSearch">搜索</el-button>
                </span>
            </div>
            <!-- 表格数据 -->
            <el-table v-loading="loading" :header-cell-style="{
                    textAlign: 'center',
                    color: '#333333',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    backgroundColor: '#FAFAFA',
                }" :data="onlineJiaTable" style="width: 100%" max-height="500">
                <el-table-column prop="courseName" label="教程名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="diseaseType" label="病种" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="章节标题" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="onlineJiaSend(scope.$index, scope.row)" type="text"
                            size="small">
                            发送
                        </el-button>
                    </template>
                </el-table-column>
                <template slot="empty"
                    v-if="$store.state.userPlatForm === 'platForm' && defaultIdType === 'hospitalId'">
                    <!-- 仅平台有 -->
                    <div>
                        <div>对应机构暂无数据，是否去平台查找</div>
                        <el-button type="primary" @click="companySearchOnline">搜平台</el-button>
                    </div>
                </template>
                <template slot="empty" v-if="defaultIdType === 'companyId' && !onlineJiaTable.length">
                    <!-- 平台搜索过后也无数据的情况下展示 -->
                    <div>
                        <div>暂无数据</div>
                    </div>
                </template>
            </el-table>
            <!-- 分页 -->
            <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
                <el-pagination background @size-change="onlineJiaPageSize" @current-change="onlineJiaCurrentChange"
                    :current-page="onlineJiaCurrent" :page-size="onlineJiaPage"
                    layout="total,  prev, pager, next, jumper" :total="onlineJiaTotal">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { apitTrainChapter } from '../api/index.js'
export default {
    data() {
        //这⾥存放数据
        return {
            loading:false,
            onlineJia: false, //在线教程弹出框显示隐藏
            onlineJiaPage: 10, //每页条数
            onlineJiaCurrent: 1, // 初始显示那一页
            onlineJiaTotal: 0, // 总条数
            onlineJiaTable: [], //列表数据
            keyWord: "",
            defaultIdType: "hospitalId",
        };
    },
    //监听属性类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //⽅法集合
    methods: {
        //选中
        onlineJiaSend(index,row){
            row.emitType = '在线教程';
            this.$emit('receiveParams',row)
            this.onlineJia = false;
        },
        onlineJiaCurrentChange(val) {
            this.onlineJiaCurrent = val;
            this.trainChapter();
        },
        onlineJiaPageSize(val) {
            this.onlineJiaCurrent = val;
            this.trainChapter();
        },
        //重置
        restSearch() {
            this.keyWord = ''
        },
        //搜索
        onSearch() {
            this.onlineJiaCurrent = 1;
            this.trainChapter();
        },
        //获取数据
        trainChapter() {
            this.onlineJia = true;
            this.loading = true;
            apitTrainChapter({
                current: this.onlineJiaCurrent,
                tagId: 7,
                available: 1,
                keyWord: this.keyWord,
                isLaunched: "1",
            }).then(res => {
                this.onlineJiaTable = res.data.records;
                this.onlineJiaTotal = res.data.total;
                this.loading=false;
            })
        },
        //搜平台
        companySearchOnline() {
            this.defaultIdType = "companyId";
            this.trainChapter();
        },
    },
    //⽣命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //⽣命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.$on('openDialog', () => {
                this.trainChapter()
            });
        });
    },
    //beforeCreate() {}, //⽣命周期 - 创建之前
    //beforeMount() {}, //⽣命周期 - 挂载之前
    //beforeUpdate() {}, //⽣命周期 - 更新之前
    //updated() {}, //⽣命周期 - 更新之后
    //beforeDestroy() {}, //⽣命周期 - 销毁之前
    //destroyed() {}, //⽣命周期 - 销毁完成
    //activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
/* @import url(); 引⼊公共css类 */
</style>